import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/shared/services/http.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
})
export class ForgetPasswordComponent implements OnInit {
  public show: boolean = false;
  public emailForm: FormGroup;
  public otpForm: FormGroup;
  public passwordForm: FormGroup;
  public isEmailSent: boolean = false;
  public isOtpVerified: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpService
  ) {}

  ngOnInit() {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]], // 4-digit OTP
    });

    this.passwordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirm_password: ['', [Validators.required]],
    });
  }

  togglePasswordVisibility() {
    this.show = !this.show;
  }

  sendEmail() {
    const email = this.emailForm.value.email;
    this.http.post('send_email', { email }, true).subscribe(
      (res: any) => {
        console.log('Email sent successfully', res);
        this.isEmailSent = true;
      },
      (err: any) => {
        console.error('Error sending email', err);
      }
    );
  }

  verifyOtp() {
    const { otp } = this.otpForm.value;
    const email = this.emailForm.value.email;
    this.http.post('verify_otp', { email, otp }, true).subscribe(
      (res: any) => {
        console.log('OTP verified successfully', res);
        this.isOtpVerified = true;
      },
      (err: any) => {
        console.error('Error verifying OTP', err);
      }
    );
  }

  resetPassword() {
    const { password, confirm_password } = this.passwordForm.value;
    const email = this.emailForm.value.email;
    this.http.post('forget_password', { email, password, confirm_password }, true).subscribe(
      (res: any) => {
        console.log('Password reset successfully', res);
        this.router.navigate(['/auth/login']);
      },
      (err: any) => {
        console.error('Error resetting password', err);
      }
    );
  }
}
